import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, NavigationEnd, NavigationStart, ActivationEnd, ActivatedRouteSnapshot } from '@angular/router';
import { NavigationBackService } from './navigation/navigation-history.service';
import { LocationInfoService } from './location/location-info.service';
import { UserInfoService, IUserProfile } from './user/user-info.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	standalone: false
})
export class AppComponent implements OnInit{
	origianlEnableNavigationBar: boolean = false;
	enableNavigationBar: boolean = false;
	enableIdleTimeout: boolean = false;

	constructor(
		private backSrv: NavigationBackService,
		private locationInfo: LocationInfoService,
		private router: Router,
		private userInfo: UserInfoService,
		private location: Location
	) {
		this.origianlEnableNavigationBar = window.location.search.toLowerCase().match("nonavigationbar=") ? false : true;
		this.enableIdleTimeout = window.location.search.toLowerCase().match("noidle=") ? false : true;
		// see if user ask no idle witin same session ebfore
		if (!this.enableIdleTimeout) {
			localStorage.setItem("noidle", "true");
		}
		else if (localStorage.getItem("noidle") != null && localStorage.getItem("noidle") === "true") {
			this.enableIdleTimeout = false;
		}
	}

	restoreScrollLocationMaxDuration = 15000;
	restoreScrolLocationIntervalDuration = 500;
	restoreScrollLocationEllapsedTime = 0;
	restoreScrollLocation() {
		this.restoreScrollLocationEllapsedTime = 0;
		const restoreScrollLocationSetInterval = setInterval(() => {
			this.restoreScrollLocationEllapsedTime += this.restoreScrolLocationIntervalDuration;
			if (this.restoreScrollLocationEllapsedTime > this.restoreScrollLocationMaxDuration) {
				clearInterval(restoreScrollLocationSetInterval);
			}
			const clientHeight = document.querySelector('html').clientHeight;
			const scrollHeight = document.querySelector('html').scrollHeight;
			if (scrollHeight > clientHeight) {
				let backUrls = JSON.parse(sessionStorage[this.backSrv.storageName])
				if (backUrls != null && backUrls.length > 0 && this.location.path() === backUrls[backUrls.length - 1].url) {
					document.documentElement.scrollTop = backUrls[backUrls.length - 1].ScrollTop;
					clearInterval(restoreScrollLocationSetInterval);
				}
			}

		}, this.restoreScrolLocationIntervalDuration);
	}

	async ngOnInit() {
		// check if we need to add navigation bar, idle timeout
		this.router.events.subscribe(
			event => {
				if (event instanceof ActivationEnd) {
					let snapshot = (<ActivationEnd>event).snapshot;
					if (snapshot) {
						let data = (<ActivatedRouteSnapshot>snapshot).data;
						if (data) {
							// no navigation bar?
							if (data["noNavigator"] != null && data["noNavigator"] === true) {
								this.enableNavigationBar = false;
							}
							else if (data["authenticate"] != null) {
								this.enableNavigationBar = this.origianlEnableNavigationBar;
							}
							// no idle timeout?
							if (data["noIdle"] != null && data["noIdle"] === true) {
								this.enableIdleTimeout = false;
							}
						}
					}
				}
				else if (event instanceof NavigationEnd) {
					//poll for scroll height to be added so we can set stored scroll position
					this.restoreScrollLocation();
					
					let user: IUserProfile = this.userInfo.getProfile();
					let isAnonymous: boolean = this.userInfo.isAnonymous();
					let url: string = (<NavigationEnd>event).url.toLowerCase();

					try {
						if (event.urlAfterRedirects !== '/Splash') {
							this.backSrv.addBackUrl(event.urlAfterRedirects);
						}
					}
					catch (ex) { console.log(ex); }

					if (url.indexOf('login') < 0
						&& url.indexOf('singup') < 0
						&& url.indexOf('resetpassword') < 0
						&& url.indexOf('embedoccupation') < 0
					) {
						if (isAnonymous || (user.ZipCode ?? "") === "") {
							this.locationInfo.getZipCodeByGeo();
						}
					}
				}
				else if (event instanceof NavigationStart) {
					let backUrls = JSON.parse(sessionStorage[this.backSrv.storageName]);
					if (event.url !== '/Splash' && event.url !== backUrls[backUrls.length - 1].url) {
						//when leaving page store scroll position for back button
						this.backSrv.updateCurrentEntryScrollTop(window.scrollY);
					} 
					
				}
			}
		);
	}
}
